import * as React from 'react';
import './DifferentissueView.scss';
// import Breadcrumbs from 'src/components/common/Breadcrumbs';
import i18n from 'src/translation/i18n';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
import env from 'src/shared/env';
// import {
//   damagedPartsUrl,
//   defectivePartsUrl,
//   warrantyClaimUrl
// } from 'src/utils/navigation';
// import WarrantyClaim from '../WarrantyClaim/WarrantyClaim';
// import { withI18n } from 'react-i18next';
// import Button from '@material-ui/core/Button';

interface IDifferentissueViewProps {
  t?: any;
}
const DifferentissueView: React.FC<IDifferentissueViewProps> = props => {
  const { t } = props;

  return (
    <div className="Differentissue-view">
      {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
        <div className="content-wrapper">
          <h5>{i18n.t('differentissue.shipmentinquiries')}</h5>
          <p>
            {i18n.t('differentissue.pleasecontact')} <b>1-800-663-6060</b>
            {i18n.t('differentissue.sendemail')}{' '}
            <a href="mailto:rpinfo@reliableparts.com">
              rpinfo@reliableparts.com
            </a>
          </p>
        </div>
      ) : (
        <div className="content-wrapper-us">
          <h5>WHICH ISSUE ARE YOU EXPERIENCING WITH YOUR ORDER</h5>
          {/* <p>
            Please fill out the{' '}
            <span>
              <a href="https://reliableparts.net/us/wp-content/uploads/sites/2/2020/04/Part-Discrepancy-Form-3.pdf">
                Discrepancy Form
              </a>
            </span>{' '}
            and send it to <a>customerservice@reliableparts.com</a>
          </p> */}
          <div className="whole-wrapper d-flex">
            <div className="wrong-quantity">
              <p>Received the wrong quantity</p>
              <p>Received someone else's order</p>
              <p>Received wrong part or missing a part</p>
              <p>Received a used part</p>
              <div className="contactinfo">
                <p>
                  Please fill out the{' '}
                  <a
                    href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Customer-Service-Part-Discrepany-Form.pdf`}
                    target="_blank"
                  >
                    Part Discrepancy Form.
                  </a>
                </p>
                <p>
                  E-mail the form to{' '}
                  <a href="mailto:customerservice@reliableparts.com">
                    customerservice@reliableparts.com
                  </a>
                </p>
              </div>
            </div>
            <div className="usedpart">
              <p>My package has been lost</p>
              <p>My part doesn't match the diagram</p>
              <div className="contactinfo">
                <p>
                  Please fill out the{' '}
                  <a
                    href={`${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Warranty-Part-Discrepancy-Form.pdf`}
                    target="_blank"
                  >
                    Part Discrepancy Form.
                  </a>
                </p>
                <p>
                  E-mail the form to{' '}
                  <a href="mailto:warranty.claims.us@reliableparts.com">
                    warranty.claims.us@reliableparts.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DifferentissueView;
